export const dedupeContentsById = <T extends {id?: number | string | null}>(contents: T[]) => {
    const seenIds = new Set<number | string>();

    return contents.filter((content) => {
        if (!content?.id) return true;
        if (seenIds.has(content.id)) return false;

        seenIds.add(content.id);
        return true;
    });
};
